/**
 * 안드로이드 앱 설치 배너(AppInstallBanner)의 첫 페인트 전 판정.
 *
 * 서버 컴포넌트(RootDocument)가 인라인 스크립트로 넣어야 해서 "use client" 모듈 밖에 둔다
 * (클라이언트 모듈의 상수를 서버에서 import 하면 문자열이 아니라 클라이언트 참조가 된다).
 *
 * 스크립트는 <html data-app-banner="1"> 을 단다. 홈 SSR 이 그려 둔 빈 자리
 * ([data-app-banner-slot])가 이 속성으로 보이게 되어(globals.css), 하이드레이션 뒤 배너가
 * 끼어들며 콘텐츠를 ~57px 밀어내던 CLS 가 사라진다(감사 06 #9). 조건은 AppInstallBanner 의
 * effect 와 같다: 안드로이드 · Capacitor 앱 아님(androidBridge 는 JavascriptInterface 라
 * 페이지 스크립트보다 먼저 있다) · 이 세션(탭)에서 닫지 않음.
 */

// sessionStorage 기준 — 탭(세션)을 닫았다 다시 열면 또 노출된다.
export const APP_BANNER_DISMISS_KEY = "locarora-app-banner-dismissed";
export const APP_BANNER_HTML_ATTR = "data-app-banner";

export const APP_INSTALL_BANNER_SCRIPT = `try{if(/android/i.test(navigator.userAgent)&&!window.androidBridge&&!(window.Capacitor&&window.Capacitor.isNativePlatform&&window.Capacitor.isNativePlatform())){var d=null;try{d=sessionStorage.getItem(${JSON.stringify(APP_BANNER_DISMISS_KEY)})}catch(e){}if(!d)document.documentElement.setAttribute(${JSON.stringify(APP_BANNER_HTML_ATTR)},"1")}}catch(e){}`;
